module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Der Autor")]), _vm._v(" "), _c('p', [_vm._v("Conrad Ferdinand Meyer (* 11. Oktober 1825 in Zürich; † 28. November 1898 in Kilchberg bei Zürich) war ein Schweizer Dichter des Realismus, der (insbesondere historische) Novellen, Romane und lyrische Gedichte geschaffen hat. Er gehört mit Gottfried Keller und Jeremias Gotthelf zu den bedeutendsten deutschsprachigen Schweizer Dichtern des 19. Jahrhunderts.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("~ ~ ~")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Werke u.a.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1871 Huttens letzte Tage")]), _vm._v(" "), _c('li', [_vm._v("1876 Jörg Jenatsch")]), _vm._v(" "), _c('li', [_vm._v("1877 Der Schuß von der Kanzel")]), _vm._v(" "), _c('li', [_vm._v("1882 Gustav Adolfs Page")]), _vm._v(" "), _c('li', [_vm._v("1884 Die Hochzeit des Mönchs")]), _vm._v(" "), _c('li', [_vm._v("1891 Angela Borgia")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 57
// module chunks = 0